import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { HubbixCommonConfigurationModule } from '@hubbix/common-components/configuration';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import {
  AUTHENTICATION_SERVICE,
  AuthenticationService as HubbixAuthenticationService,
} from '@hubbix/common-components/authentication';
import { AuthenticationService } from '../services/authentication.service';

export function provideAuthentication(): EnvironmentProviders {
  return makeEnvironmentProviders([
    HubbixCommonConfigurationModule,
    AuthenticationService,
    {
      provide: HubbixAuthenticationService,
      useExisting: AuthenticationService,
    },
    {
      provide: AUTHENTICATION_SERVICE,
      useExisting: AuthenticationService,
    },
    provideOAuthClient({ resourceServer: { sendAccessToken: true } }),

    // permet de configurer et d'initialiser le flow d'authentification
    // dès l'initialisation de l'application
    // et d'attendre la fin de l'authentification avant le bootstrap de l'app
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (authenticationService: AuthenticationService) => {
        return async () => authenticationService.load();
      },
      deps: [AuthenticationService],
    },
  ]);
}
